import { render, staticRenderFns } from "./noMore.vue?vue&type=template&id=ddf2d1ee&scoped=true&"
import script from "./noMore.vue?vue&type=script&lang=js&"
export * from "./noMore.vue?vue&type=script&lang=js&"
import style0 from "./noMore.vue?vue&type=style&index=0&id=ddf2d1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf2d1ee",
  null
  
)

export default component.exports